import(/* webpackMode: "eager" */ "/opt/trendrain/trendrain-web/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/trendrain/trendrain-web/src/app/trend/[id]/TrendDetailClient.tsx");
